module.exports = __webpack_public_path__ + "img/company38.d1f4d7c4.png";